import { push } from 'redux-first-history';
import { buildRoute } from '../utils/routes';

import { RESET_DEVICE_DETAILS } from './';

export default () => {
  return async (dispatch, getState) => {
    const {
      group: { slug },
    } = getState();

    await dispatch({ type: RESET_DEVICE_DETAILS });
    await dispatch(push(buildRoute(slug, 'device')));
  };
};
